// src/App.jsx
import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './components/layout/Navbar';
import Hero from './components/hero/Hero';
import About from './components/about/About';
import Skills from './components/skills/Skills';
import Projects from './components/projects/Projects';
import Timeline from './components/timeline/Timeline';
import Thinking from './components/thinking/Thinking';
import Contact from './components/contact/Contact';
import Footer from './components/layout/Footer';
import Vision from './pages/Vision';

function App() {
  const [darkMode, setDarkMode] = React.useState(() => {
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  React.useEffect(() => {
    const handler = (e) => {
      if (e.key === 't') {
        setDarkMode((prev) => !prev);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  React.useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  const isDebugMode = window.location.search.includes('debug=true');

  return (
    <Router>
      <div className="relative min-h-screen bg-gradient-to-br from-[#0f0f0f] via-[#141414] to-[#1a1a1a] text-white transition-colors duration-300 overflow-x-hidden">
        {/* Ambient Frosted Glass Effect */}
        <div className="absolute inset-0 -z-10">
          <div className="h-full w-full bg-black/50 backdrop-blur-2xl backdrop-saturate-150" />
        </div>

        <Navbar onToggleTheme={() => setDarkMode((d) => !d)} darkMode={darkMode} />

        <Routes>
          <Route
            path="/"
            element={
              <AnimatePresence mode="wait">
                <motion.main
                  key={darkMode ? 'dark' : 'light'}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.4 }}
                  className="space-y-16 md:space-y-28 px-4 md:px-12 lg:px-24"
                >
                  <Hero
                    headline="I build intelligent systems that"
                    animatedWords={["scale", "adapt", "self-optimize"]}
                    subtext="Backend AI Engineer · FastAPI · Transformers · Docker · Infra"
                    ctaPrimary="Explore Projects"
                    ctaSecondary="Resume"
                  />
                  <About />
                  <Skills />
                  <Projects />
                  <Timeline />
                  <Thinking />
                  <Contact />
                </motion.main>
              </AnimatePresence>
            }
          />

          {isDebugMode && <Route path="/vision" element={<Vision />} />}
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;